// The hero's segmented bar (ux/03 Header): one 6 px pill per item, like
// workout splits — up to PILL_LIMIT items. Past that, pills would be slivers,
// so the same parts become one continuous bar, each part as wide as its share.

export const PILL_LIMIT = 20

/** One part of the bar: filled or not (phone) or a category tint (desktop), and its share. */
export type Part<F> = { fill: F; weight: number }
export type Segments<F> = { bar: boolean; parts: Part<F>[] }

/** Phone: the trip, filled once an item is in the basket. */
export function basketSegments(inBasket: number, total: number): Segments<boolean> {
  if (total <= PILL_LIMIT) {
    return { bar: false, parts: Array.from({ length: total }, (_, i) => ({ fill: i < inBasket, weight: 1 })) }
  }
  const parts = [{ fill: true, weight: inBasket }, { fill: false, weight: total - inBasket }]
  return { bar: true, parts: parts.filter(p => p.weight > 0) }
}

/** Desktop: the list split by category, in each category's tint. */
export function splitSegments(groups: { tint: string; count: number }[]): Segments<string> {
  const total = groups.reduce((n, g) => n + g.count, 0)
  if (total <= PILL_LIMIT) {
    return { bar: false, parts: groups.flatMap(g => Array.from({ length: g.count }, () => ({ fill: g.tint, weight: 1 }))) }
  }
  return { bar: true, parts: groups.filter(g => g.count > 0).map(g => ({ fill: g.tint, weight: g.count })) }
}
